import { Injectable } from '@angular/core';
import { EstatusJSON } from '../../models/EstatusJSON';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';
import { IApiBase } from './Interface/IApiBase.interface';

@Injectable({
  providedIn: "root",
})
export class NotificationsAPIService implements IApiBase{
configUrl: string;
public Result;
estatus: EstatusJSON;

constructor(private http: HttpClient) {
  this.configUrl = environment.host;
  this.estatus = new EstatusJSON();
}
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }

  GetWebWithoutStatusPage(page: number): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Notification/GetWebWithoutStatusPage?page="+page, {});
  }
  
  GetNotificationsActiveCount(): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Notification/GetNotificationsActiveCount", {});
  }
  
  DeactivateWebNotifications(): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Notification/DeactivateWebNotifications", {});
  }
  
  DeactivateWebNotificationById(id: number): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Notification/DeactivateWebNotificationById?id="+id, {});
  }

  //paginacion
    getFilterValues(request : FilterRequest[]): any {
      return this.http.post<EstatusJSON>(this.configUrl + "/api/Notification/GetFilterValues", request);
    }
  
    getPage(request : CatalogPaginationRequest): any {
      return this.http.post<EstatusJSON>(this.configUrl + "/api/Notification/GetNotificationsPage", request);
    }
  
    getCount(request : CatalogPaginationRequest): any {
      return this.http.post<EstatusJSON>(this.configUrl + "/api/Notification/GetNotificationsCount", request);
    }
}
